module.exports = __webpack_public_path__ + "static/img/collect_empty.5890a85.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/collect/collect_empty.png
// module id = E2Z3
// module chunks = 1